import {
  SiteDetailsManualHostingDeploysEnabledFieldsFragmentDoc,
  SiteDetailsManualHostingDeploysEnabledFieldsFragment,
} from "@modules/site/settings/fragments.generated"

import { useToggleManualHostingDeploysMutation } from "@modules/site/settings/queries.generated"
import { useTriggerErrorAlert } from "@modules/ui/components/ErrorAlert"

export function useToggleManualHostingDeploys(siteId: string) {
  const [
    toggleManualHostingDeploysMutation,
    { loading },
  ] = useToggleManualHostingDeploysMutation()
  const [setError, errorAlert] = useTriggerErrorAlert()

  const toggleManualHostingDeploys = () => {
    setError(null)
    return toggleManualHostingDeploysMutation({
      variables: {
        siteId,
      },
      update: (proxy, { data }) => {
        if (!data?.toggleManualHostingDeploys?.success) {
          return
        }

        const fragmentInfo = {
          id: `Site:${siteId}`,
          fragment: SiteDetailsManualHostingDeploysEnabledFieldsFragmentDoc,
        }

        const site = proxy.readFragment<
          SiteDetailsManualHostingDeploysEnabledFieldsFragment
        >(fragmentInfo)
        if (!site) {
          return
        }

        site.manualHostingDeploysEnabled = !site.manualHostingDeploysEnabled
        proxy.writeFragment<
          SiteDetailsManualHostingDeploysEnabledFieldsFragment
        >({
          ...fragmentInfo,
          data: site,
        })
      },
      optimisticResponse: {
        toggleManualHostingDeploys: {
          success: true,
          message: null,
          __typename: `MutationResult`,
        },
      },
    }).catch(err => setError(err))
  }

  return [toggleManualHostingDeploys, { loading, errorAlert }] as const
}
